import { FlaskConical } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api, BASE_PATH } from '../../../api.ts';
import { useMe } from '../../../auth.tsx';
import { Button } from '../../../components/ui.tsx';

/**
 * Testar como cliente (ADR 0227): faixa fixa no topo enquanto a pessoa da equipe usa a área do
 * cliente com a conta de teste dela, com o botão que volta para o painel. A sessão de teste leva o
 * "amr" test_client (ADR 0131 do Ground Up).
 */
export function TestClientBanner() {
  const { t } = useTranslation();
  const me = useMe();
  const [busy, setBusy] = useState(false);
  if (!me.data?.authMethods?.includes('test_client')) return null;
  const back = async () => {
    setBusy(true);
    try {
      const res = await api.post<{ signedIn: boolean }>('/portal/test-client/return');
      window.location.assign(`${BASE_PATH}${res.signedIn ? '/factory/client-view' : '/login'}`);
    } catch {
      setBusy(false);
    }
  };
  return (
    <div
      role="status"
      className="sticky top-0 z-10 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-brand bg-brand-soft p-3 text-sm"
    >
      <span className="flex items-center gap-2">
        <FlaskConical size={16} aria-hidden />
        {t('factory.portal.testClient.banner')}
      </span>
      <Button variant="secondary" onClick={back} disabled={busy}>
        {t('factory.portal.testClient.back')}
      </Button>
    </div>
  );
}
